// extracted by mini-css-extract-plugin
export default {"videoOverlayLoader":"videoOverlayLoader__videoOverlayLoader__QIKQw","displayed":"videoOverlayLoader__displayed__sx0Dy"};